import { featuredRoundups } from '@/mocks/homeContent';

export default function FeaturedRoundups() {
  return (
    <section id="featured" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span> Featured Picks
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-950 md:text-4xl">
              重磅专题合集 <span className="text-primary-600">·</span> 编辑首推
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            由编辑部按热度与完整度挑出的三份大合集，每一份都是一条可以追到底的完整脉络。
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {featuredRoundups.map((r, i) => (
            <a
              key={r.title}
              href="#library"
              className="group relative block h-[420px] overflow-hidden rounded-lg cursor-pointer md:h-[520px]"
            >
              <img
                src={r.image}
                alt={r.title}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/35 to-transparent"></div>

              <span className="absolute left-4 top-4 font-display text-6xl font-black text-background-50/15">
                {String(i + 1).padStart(2, '0')}
              </span>

              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-semibold text-background-50 whitespace-nowrap">
                  <i className="ri-folder-open-line text-xs"></i>
                  {r.kicker}
                </span>
                <h3 className="mt-3 font-display text-2xl font-black leading-snug text-background-50 md:text-[26px]">
                  {r.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-background-50/75">{r.desc}</p>

                <div className="mt-4 flex items-center justify-between border-t border-background-50/15 pt-3">
                  <span className="flex items-center gap-1.5 text-xs text-background-50/70">
                    <i className="ri-file-list-3-line text-sm"></i>
                    {r.meta}
                  </span>
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-primary-600 transition-all group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}